<template>
    <div id="page-duplication-detail">
        <div class="vx-card pr-5 pl-5">
            <vs-table 
                :data="unders"
                :max-items="itemsPerPage"
                pagination
                :stripe="true"
                search
            >
                <template slot="header">
                    <!-- ITEMS PER PAGE -->
                    <div class="flex-grow">
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div class="p-3 border border-solid d-theme-border-grey-light rounded-full cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2">
                                    {{ itemsPerPage }}
                                </span>
                                <feather-icon
                                    icon="ChevronDownIcon"
                                    svgClasses="h-4 w-4"
                                />
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item :key="ipp" v-for="ipp in [15,25,50,100]" @click="itemsPerPage = ipp"><span>{{ipp}}</span></vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                        <vx-button class="mr-5" color="primary" type="border" :active="date == 'this_week'" :to="{ name: 'under', query: { date: 'this_week' }  }">Tuần này</vx-button>
                        <vx-button class="mr-5" color="success" type="border" :active="date == 'last_week'" :to="{ name: 'under', query: { date: 'last_week' } }">Tuần trước</vx-button>
                    </div>
                </template>
                <template slot="thead">
                    <vs-th
                        :key="idx"
                        v-for="(h,idx) in header"
                        :sort-key="h.field"
                    >
                        {{ h.title }}
                    </vs-th>
                </template>
                <template slot-scope="{ data }">
                    <vs-tr :key="data[indextr].member_name+'_'+data[indextr].cheat_id" v-for="(tr, indextr) in data">
                        <vs-td :key="idx" v-for="(h,idx) in header" :data="data[indextr][h.field]">
                            <template v-if="h.field == 'member_name'">
                                {{ data[indextr][h.field].toUpperCase() }}
                            </template>
                            <template v-else-if="h.render">
                                {{ h.render(data[indextr][h.field]) }}
                            </template>
                            <template v-else>
                                {{ data[indextr][h.field] }}
                            </template>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import vSelect from 'vue-select';
import moment from 'moment';
import { AclRule } from 'vue-acl';

export default {
    data(){
        return {
            itemsPerPage: 15,
            header: [],
            unders: [],
            cheat: {},
            date: ""
        }
    },
    components: {
        vSelect
    },
    beforeRouteUpdate (to, from, next) {
        this.date = to.query.date;
        this.fetchUnder(to.query.date);
       
        next();
    },
    computed: {
        fetchUnderPermission(){
            return new AclRule('store_under').generate();
        },
    },
    methods:{
        fetchUnder(date) {
            if(this.$acl.not.check('fetchUnderPermission')) return;
            
            let vm = this;
            
            this.$http.get(`under?date=${date}`).then((res) => {
                vm.unders = res.data.data;

                let cheat = {};
                let msg = res.data.msg.split(";").forEach((item, index) => {
                    let sp = item.trim().split(":");
                    cheat[parseInt(sp[0].trim())] = sp[1];
                }); //1:Xỉu 1 mặt; 2:Xỉu dưới
                vm.cheat = cheat;
            });
        },
        initHeader(){
            let vm = this;

            this.header = [ 
                { title:"Member", field:"member_name" }, 
                { title:"Bet dưới xỉu/Tổng bet", field:"note" }, 
                { title:"Cảnh báo", field:"cheat_id", render: function(val){ return vm.cheat[val] ? vm.cheat[val] : "???" } }, 
                { title:"Từ ngày", field:"start_date", render: function(val){ return moment(val).format("DD-MM-YYYY"); } }, 
                { title:"Đến ngày", field:"end_date", render: function(val){ return moment(val).format("DD-MM-YYYY"); } }
            ];
        },
        trimDate(datetime){
            return moment(datetime).format("YYYY-MM-DD");
        }
    },
    created(){
        this.initHeader();

        if(this.$route.query.date && this.$route.query.date == "this_week") {
            this.date = "this_week";
            this.fetchUnder("this_week");
            return;
        }
        this.$router.replace({ name: 'under', query: { date: 'this_week' } });
    }
};
</script>

<style>
.swal2-container{
    z-index: 99999;
}
</style>
